import React from 'react';

export const AdminEmptyState = ({ icon: Icon, text }) => <div data-testid="admin-empty-state" className="flex flex-col items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-slate-50 py-16 text-center"><Icon className="h-8 w-8 text-slate-300" /><p className="mt-3 max-w-sm text-sm text-slate-500">{text}</p></div>;

export function formatDate(value, lang) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString(lang === 'es' ? 'es-ES' : 'en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

export const adminButtonClass = 'flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2.5 text-sm font-semibold text-slate-700 transition-colors duration-200 hover:bg-slate-50 disabled:opacity-50';

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url; link.download = filename;
  link.dataset.testid = 'admin-csv-download-link';
  document.body.appendChild(link); link.click(); link.remove();
  URL.revokeObjectURL(url);
}